import axios from 'axios';

const BACKEND_URI = process.env.VITE_BACKEND_URI;

/**
 * Obține un token single-use pentru transcrierea realtime ElevenLabs (Scribe v2 Realtime).
 *
 * Tokenul e emis de backend (`GET /realtime/token`, JWT-guarded), expiră în 15 minute și e
 * single-use — cheia `ELEVENLABS_API_KEY` rămâne pe server, nu ajunge niciodată în browser.
 * La ședințe lungi se cere un token nou la reconectare.
 */
export async function fetchRealtimeToken(): Promise<string> {
  const res = await axios.get(`${BACKEND_URI}/realtime/token`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  return res.data.token as string;
}

/** Jurnalizează o sesiune de dictare live (durată audio) în monitorizarea AI. */
export async function logRealtimeSession(opts: { durationSec: number; error?: string }): Promise<void> {
  try {
    await axios.post(
      `${BACKEND_URI}/realtime/session`,
      { durationSec: Math.max(0, Math.round(opts.durationSec)), error: opts.error || undefined },
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } },
    );
  } catch {
    /* jurnalul nu trebuie să blocheze dictarea */
  }
}

/** Transcrie un clip scurt cu GPT-4o Transcribe (dictare chat). */
export async function transcribeDictation(blob: Blob, durationSec: number, language = 'ro'): Promise<string> {
  const fd = new FormData();
  const ext = blob.type.includes('mp4') ? 'mp4' : blob.type.includes('wav') ? 'wav' : 'webm';
  fd.append('audio', blob, `dictation.${ext}`);
  fd.append('language', language);
  fd.append('durationSec', String(Math.max(0, Math.round(durationSec))));
  const res = await axios.post(`${BACKEND_URI}/assistant/transcribe`, fd, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  return String(res.data?.text || '').trim();
}
